import angular from 'angular';
import template from './template.jade';
import './styles.styl';

export default angular
	.module('ui.cian.input-wrapper', [])
	.directive('cianUiInputWrapper', () => ({
		restrict: 'AE',
		scope: {},
		bindToController: {
			cuiInvalid: '=',
			cuiRequired: '='
		},
		controller() {},
		link: (scope, el) => {
			const $input = el[0].querySelector('input');
			$input.classList.add('cui-input-wrapper__input');
		},
		controllerAs: 'input',
		transclude: true,
		replace: true,
		template
	}))
	.name;
